// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27MrS","newExpiryDate":"styles_newExpiryDate__3SOXD","footer":"styles_footer__12Zvq"};